var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#5D5F63"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pricing"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 796,
    transform: "translate(-812 -324)",
    fill: "#EDF0F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no-results 1",
    opacity: 0.5,
    clipPath: "url(#clip0_1234_19078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M78.4375 35.1823V14.0625H1.5625V63.9844C1.5625 67.4359 4.36094 70.2344 7.8125 70.2344H61.7109L70 78.4375L76.0938 72.5L73.6516 70.0609C76.3969 69.4031 78.4375 66.9313 78.4375 63.9844V48.9844",
    stroke: "#52647E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M78.4375 14.0625H1.5625V7.8125C1.5625 4.36078 4.36078 1.5625 7.8125 1.5625H72.1875C75.6392 1.5625 78.4375 4.36078 78.4375 7.8125V14.0625Z",
    stroke: "#52647E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.375 7.8125H23.4375",
    stroke: "#52647E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M56.5625 7.8125H70.625",
    stroke: "#52647E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M40 63.9844C51.8655 63.9844 61.4844 54.3655 61.4844 42.5C61.4844 30.6345 51.8655 21.0156 40 21.0156C28.1345 21.0156 18.5156 30.6345 18.5156 42.5C18.5156 54.3655 28.1345 63.9844 40 63.9844Z",
    stroke: "#52647E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40 57.7344C48.4137 57.7344 55.2344 50.9137 55.2344 42.5C55.2344 34.0863 48.4137 27.2656 40 27.2656C31.5863 27.2656 24.7656 34.0863 24.7656 42.5C24.7656 50.9137 31.5863 57.7344 40 57.7344Z",
    stroke: "#52647E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M46.0763 48.5767L33.9229 36.4233",
    stroke: "#52647E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M46.0763 36.4233L33.9229 48.5767",
    stroke: "#52647E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M61.9113 59.9906L57.491 64.4109L52.8223 59.7422C54.5004 58.4906 55.991 57 57.2426 55.3219L61.9113 59.9906Z",
    stroke: "#52647E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M76.0934 72.5L69.9996 78.4375L56.6621 65.2391L62.7387 59.1625L76.0934 72.5Z",
    stroke: "#52647E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1234_19078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.ba426f4a07eacfa10b5601aceffca7d8.svg";
export { ForwardRef as ReactComponent };